import { Check, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { http, errMsg, fileUrl } from "@/lib/api";

export const TakesStrip = ({ s, reload }) => {
  const takes = s.takes_list || [];
  if (takes.length < 2 && s.status !== "generating") return null;
  const busy = s.status === "generating";
  const pick = async (t) => {
    if (t.id === s.current_take) return;
    try { await http.post(`/scenes/${s.id}/takes/${t.id}/select`); await reload(); } catch (e) { toast.error(errMsg(e)); }
  };
  const drop = async (t) => {
    if (!window.confirm("Delete this take?")) return;
    try { await http.delete(`/scenes/${s.id}/takes/${t.id}`); await reload(); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="space-y-1.5" data-testid="takes-strip">
      <div className="font-mono text-[10px] tracking-widest text-slate-500">TAKES — PICK ONE, THEN APPROVE</div>
      <div className="flex gap-2 overflow-x-auto pb-1">
        {takes.map((t, i) => {
          const cur = t.id === s.current_take;
          return (
            <div key={t.id} className="relative shrink-0 group">
              <button data-testid={`take-${i + 1}`} disabled={busy} onClick={() => pick(t)}
                className={`block w-32 aspect-video rounded overflow-hidden border-2 transition-colors ${cur ? "border-amber-400" : "border-[#2A3245] hover:border-slate-400"} disabled:cursor-not-allowed`}>
                <img src={fileUrl(t.thumb_path)} alt={`Take ${i + 1}`} className="w-full h-full object-cover" />
                <span className="absolute bottom-1 left-1 font-mono text-[9px] bg-black/70 px-1.5 py-0.5 rounded flex items-center gap-1">
                  {cur && <Check className="w-2.5 h-2.5 text-amber-400" />}TAKE {i + 1}{t.trimmed_from ? " ✂" : ""}{cur && s.status === "approved" ? " · APPROVED" : ""}
                </span>
              </button>
              {!cur && !busy && (
                <button data-testid={`delete-take-${i + 1}`} title="Delete take" onClick={() => drop(t)}
                  className="absolute top-1 right-1 p-1 rounded bg-black/70 text-slate-300 hover:text-red-400 transition-colors"><Trash2 className="w-3 h-3" /></button>
              )}
            </div>
          );
        })}
        {busy && (
          <div className="shrink-0 w-32 aspect-video rounded border-2 border-dashed border-violet-500/60 grid place-items-center font-mono text-[9px] text-violet-300 scan" data-testid="take-generating">
            NEW TAKE…
          </div>
        )}
      </div>
    </div>
  );
};
